export const ENV = {
  API_URL: 'https://api.skozub.pl',
  IDENTITY_URL: 'https://auth.skozub.pl',
  WS_URL: 'wss://api.skozub.pl',
}
